import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { authService } from '../services/adminService';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isValid, setIsValid] = React.useState(null);

  useEffect(() => {
    const verify = async () => {
      const valid = await authService.verifyToken();
      setIsValid(valid);
      if (!valid) {
        navigate('/admin/login');
      }
    };
    verify();
  }, [navigate]);

  if (isValid === null) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return isValid ? children : <Navigate to="/admin/login" />;
};

export default ProtectedRoute;
